import { getAppIcon } from '@wellesley/apps'
import { cropName } from 'helpers/cropName'
import { FC } from 'react'
import { Avatar, AvatarFallback, AvatarImage, cn } from '@wellesley/ui'

export type AppAvatarProps = {
  name: string
  icons?: string[] | null
  className?: string
}

export const AppAvatar: FC<AppAvatarProps> = ({ name, icons, className }) => {
  const icon = icons && getAppIcon(icons, 40)

  return (
    <Avatar className={cn('h-xs w-6 rounded-none', className)}>
      {icon && <AvatarImage src={icon} alt="app-avatar" />}
      <AvatarFallback className="rounded-xs bg-gray-700 text-xs">
        {cropName(name)}
      </AvatarFallback>
    </Avatar>
  )
}
